<template>
  <div :class="[landscape ? 'item' : 'item-portrait']">
    <div class="wrapper">
      <img class="ai-part1" src="../../assets/ai_part1.png" alt="">
      <img class="ai-part2" src="../../assets/ai_part2.png" alt="">
      <div class="ground"></div>
      <div class="block1"></div>
      <div class="block2"></div>
      <div class="part4-wrapper">
        <img class="ai-part4" src="../../assets/ai_part4.png" alt="">
      </div>
      <img class="ai-text" src="../../assets/ai_text.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['landscape']
}
</script>

<style lang="scss" scoped>
@import '../../Global.scss';
@import './Dashboard.scss';
$width: 6.4rem;
.item {
  width: $width;
  animation: slideInRight 1s linear;
}
.item-portrait {
  .wrapper {
    width: $width;
  }
}
.ai-part1 {
  width: 2.08rem;
  height: 2.075rem;
  position: relative;
  left: 1.3rem;
  bottom: .45rem;
  animation: rolling 4s infinite linear;
}
.ai-part2 {
  width: 1.365rem;
  height: 1.175rem;
  left: 2.3rem;
  bottom: 2.1rem;
  animation: shaking 1s infinite alternate linear;
  transform-origin: 20% 140%;
}
.ai-part3 {
  width: 3.885rem;
  height: .015rem;
  left: 0rem;
  bottom: .44rem;
}
.part4-wrapper {
  width: 1.3rem;
  height: 3rem;
  overflow: hidden;
  // background: red;
  left: .3rem;
  .ai-part4 {
    width: 2.845rem;
    height: 2.56rem;
    margin-top: .1rem;
    animation: bubble 3s infinite linear;
  }
}
.ai-text {
  width: 1.65rem;
  height: 3rem;
  left: 4.1rem;
  bottom: .4rem;
}
.ground {
  width: 3.5rem;
  height: .3rem;
  left: 0rem;
  bottom: .13rem;
  border-top: .01rem solid black;
}
.block1 {
  width: .3rem;
  height: .3rem;
  border: .01rem solid $bgColor;
  background: $bgColor;
  bottom: .13rem;
  left: 3.5rem;
  animation: groundMoving 2s infinite linear;
}
.block2 {
  @extend .block1;
  animation: groundMoving 2s .4s infinite linear;
}
@keyframes rolling {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes shaking {
  from {
    transform: rotate(10deg);
  }
  to {
    transform: rotate(-5deg);
  }
}
@keyframes bubble {
  from {
    transform: translateX(1.3rem);
  }
  to {
    transform: translateX(-2.845rem);
  }
}
@keyframes groundMoving {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-4rem);
  }
}
@keyframes slideInRight {
  from {
    transform: translate(17rem);
  }
  to {
    transfrom: tranalate(0rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Part1.vue